import React from 'react';
import RichText from 'legacy-src/utility/RichText';

import { viewed } from '../shared/status';

const Player = () => {
  const { rows } = this.props.item.content;

  // TODO: Use a proper html sanitizing function.
  return (
    <table>
      {rows.map((cols, ri) => (
        <tr key={ri}>
          {cols.map((c, ci) => (
            <td key={ci}>
              <RichText content={c} />
            </td>
          ))}
        </tr>
      ))}
    </table>
  );
};

Player.displayName = 'Table';

export default { Player, status: viewed };
